import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { Admin } from '@/types';

export const useAdmin = (userId: string | undefined) => {
  const [admin, setAdmin] = useState<Admin | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setAdmin(null);
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    const checkAdminStatus = async () => {
      try {
        const adminDoc = await getDoc(doc(db, 'admins', userId));
        
        if (adminDoc.exists()) {
          const adminData = {
            id: adminDoc.id,
            ...adminDoc.data(),
          } as Admin;
          
          setAdmin(adminData);
          setIsAdmin(true);
        } else {
          setAdmin(null);
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Failed to check admin status:', error);
        setAdmin(null);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [userId]);

  return { admin, isAdmin, loading };
};
